import { Helmet } from 'react-helmet-async';

import React from 'react';
// @mui
import { styled } from '@mui/material/styles';
import { Container } from '@mui/material/';
// component
import FindPassword from './FindPassword';
// import { LoginForm } from '../sections/auth/login';
const StyledContent = styled('div')(({ theme }) => ({
  maxWidth: 600,
  height: 630,
  width: '100%',
  margin: 'auto',
  display: 'flex',
  justifyContent: 'center',
  flexDirection: 'column',
  backgroundColor: '#fff',
  padding: theme.spacing(8, 8),
  borderRadius: '30px',
  boxShadow: theme.customShadows.card,
}));

const StyledRoot = styled('div')(({ theme }) => ({
  [theme.breakpoints.up('md')]: {
    display: 'flex',
    backgroundColor: '#F5f5f5',
    minHeight: '100vh',
  },
}));

const FindPasswordPage = () => (
  <>
    <Helmet>
      <title> 비밀번호 찾기 | RainDrop </title>
    </Helmet>
    <StyledRoot>
      <Container maxWidth="sm" style={{ display: 'flex', justifyContent: 'center' }}>
        <StyledContent>
          <FindPassword />
        </StyledContent>
      </Container>
    </StyledRoot>
  </>
);
export default FindPasswordPage;
